<template>
    <div v-loading="loading" class="body">
        <span style="font-size:16px; font-weight: 600;">
            当前题库一共：
            <span style="color:red"> {{ this.$store.state.problem.question.length }} </span> 
            道题
        </span>
        <div style="float: right; margin-right:50px">
            <el-button type="success" round @click="ClickMeToAdd">增加题目</el-button>
        </div>
        <table class="table table-striped table-hover">
            <thead>
                <tr style="font-size: 14px;">
                    <th scope="col-1">题号</th>
                    <th scope="col-2">标题</th>
                    <th scope="col-3">算法标签</th>
                    <th scope="col-2">题目题解视频</th>
                    <th scope="col-2">CURD样例</th>
                    <th scope="col-2">CURD题目</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="t in showpage" :key="t.id">
                    <th class="col-1" style="font-size: 13px;" @click="ClickMeGoproblem(t)">{{ t.pbid }}</th>
                    <td class="col-2" style="font-size: 13px;" @click="ClickMeGoproblem(t)">{{ t.name }}</td>
                    <td class="col-3" style="font-size: 13px;">{{ t.altag }}</td>
                    <!-- <td class="col-2" style="font-size: 13px;">
                        
                        <el-button type="text" @click="dialogTableVisible = true">添加</el-button>
                        <el-dialog title="收货地址" :visible.sync="dialogTableVisible">
                            123
                        </el-dialog>

                        <el-button style="margin-left: 10px;" type="text" @click="dialogTableVisible = true">修改</el-button>
                        <el-dialog title="收货地址" :visible.sync="dialogTableVisible">
                            123
                        </el-dialog>

                        <el-button style="margin-left: 10px;" type="text">删除</el-button>
                    </td> -->
                    <td class="col-2" style="font-size: 13px;">
                        <button type="button" class="btn btn-sm btn-outline-secondary" style="font-size: 13px;" @click="ClickMeToCURDVideo(t)">CURD视频捏</button>
                    </td>
                    <td class="col-2" style="font-size: 13px;">
                        <button type="button" class="btn btn-sm btn-outline-secondary" style="font-size: 13px;" @click="ClickMeToCURDExample(t)">CURD样例捏</button>
                    </td>
                    <td class="col-2" style="font-size: 13px;">
                        <button type="button" class="btn btn-sm btn-outline-secondary" style="font-size: 13px;" @click="open(t)">CURD题目捏</button>
                    </td>
                </tr>
            </tbody>
        </table>
        <!-- 分页设置 -->
        <div class="block">
            <!-- :page-size="100" 表示一页100条消息，上限1000条 所以说想自定义上限可以 ==> 想要的页数k  :page-size="(1000 + k - 1) / k"-->
            <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage3"
            :page-size="1" 
            layout="prev, pager, next, jumper"
            :total="1000">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    // import $ from 'jquery'

    export default {
        name:'UpdateQuestion',
        data() {
            return {
                loading:true,
                dialogTableVisible: false,

                /* 题库修改部分 */
                currentPage3: 1, // 分页
                showpage:[], // 题库数组
                /* 这里是修改题目信息的地方 */
                id: '',
                name: '',
                difficulty: '',
                altag: '',
                problemcontent: '',
                input: '', 
                output: '',
                inexample: '',
                outexample: '',
                range: '',
                tm: '',
                pbfrom: "",
                dialogFormVisible: false,
                formLabelWidth: '120px',
            }
        },
        mounted() {
            this.$store.dispatch("problem/GetQuestionList")

            if (this.$store.state.problem.question.length != 0) {
                const Topic = this.$store.state.problem.question
                this.showpage = Topic.slice(0, Math.min(10, Topic.length))
                this.loading = false
            }
            else {
                const t = setInterval(() => {
                    if (this.$store.state.problem.question.length != 0) {
                        const Topic = this.$store.state.problem.question
                        this.showpage = Topic.slice(0, Math.min(10, Topic.length))
                        this.loading = false
                        clearInterval(t); // 清除定时器
                    }
                }, 100);
            }
        },
        methods: {
            ClickMeToCURDExample(t){ // CURD指定的题目样例
                let routeData = this.$router.resolve({
                    path:'/AboutExample',
                    query: { // 只需要传 题目的题号和题目名字过去
                        pbid: t.pbid,
                        name: t.name,
                    }
                });
                window.open(routeData.href, '_blank');
            },
            ClickMeToCURDVideo(t) {
                let routeData = this.$router.resolve({
                    path:'/AboutQuestionVideo',
                    query: { // 只需要传 题目的题号和题目名字过去
                        pbid: t.pbid,
                        name: t.name,
                    }
                });
                window.open(routeData.href, '_blank');
            },
            ClickMeToAdd() { // 增加题目 不需要带任何参数过去
                let routeData = this.$router.resolve({ 
                    path:'/AboutQuestion',
                });
                window.open(routeData.href, '_blank');
            },
            ClickMeGoproblem(t) { // 跳转路由 直接去正式题目页面
                let routeData = this.$router.resolve({
                    path:`/Problem/Content/${t.id}`,
                });
                window.open(routeData.href, '_blank');
            },
            handleSizeChange(val) { // 没啥用
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) { // 实现分页
                this.loading = true
                console.log(`当前页: ${val}`);
                setTimeout( () => {
                    const Topic = this.$store.state.problem.question
                    this.showpage.length = 0
                    this.showpage = Topic.slice((val - 1) * 10, Math.min(val * 10, Topic.length))
                    this.loading = false
                }, 300)
            },
            /* 这里是修改信息的 */
            open(t) { // 这个是修改按钮的函数
                let routeData = this.$router.resolve({
                    path:'/AboutQuestion',
                    query: {
                        id: t.id,
                        pbid: t.pbid,
                        name: t.name,
                        difficulty: t.difficulty, 
                        altag: t.altag,
                        problemcontent: t.problemcontent,
                        input: t.input, 
                        output: t.output,
                        inexample: t.inexample,
                        outexample: t.outexample,
                        range: t.pbrange,
                        tm: t.tm,
                        pbfrom: t.pbfrom,
                    }
                });
                window.open(routeData.href, '_blank');
            },
        }
    }
</script>

<style scoped>
.body {
    width: 1170px;
    min-height:165px;
    height: auto;
    margin:0 auto;
    background-color: white;
    padding: 20.8px;
    border-radius: 5px;
    box-sizing: border-box;
    border:2px solid lightgrey;
}
</style>